import Immutable from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  key: '',
  title: '',
  name: '',
  icon: '',
  description: '',
  isLoading: true,
  isLoadingModal: false
})

export default handleActions({
  SCREEN_SET_INFO: (state, action) => {
    return state.merge(action.payload)
  },
  SCREEN_LOADING: (state, action) => {
    return state.merge({isLoading: action.payload})
  },
  SCREEN_LOADING_MODAL: (state, action) => {
    return state.merge({isLoadingModal: action.payload})
  },
}, defaultState)
